import React from 'react';
import { useParams } from 'react-router-dom';
import RedactionEditor from '../components/redaction/RedactionEditor';

const RedactionEditorPage = () => {
  const { id } = useParams();
  return <RedactionEditor documentId={id} />;
};

export default RedactionEditorPage;
